import { ReactNode, useContext } from 'react';
import { DragSourceMonitor } from 'react-dnd';
import { FloatingWindow, FloatingWindowType, ViewMode } from 'types/app.types';
import FloatingWindowsContext from 'contexts/FloatingWindowsContext';
import ProductsWindow from './components/ProductsWindow';
import AlarmsWindow from './components/AlarmsWindow';
import Window from '../../../../../../../../components/Window';

interface FloatingWindowsSystemProps {
  mode: ViewMode
}

interface WindowsListProps {
  floatingWindowsList: FloatingWindow[],
  mode: ViewMode,
  onDragEnd?: (
    draggedItem : {index: string},
    monitor : DragSourceMonitor<{index: string}, unknown>) => void
}

function WindowsList({ floatingWindowsList, mode, onDragEnd } : WindowsListProps) {
  const getComponent = (type: FloatingWindowType) : ReactNode => {
    switch (type) {
      case FloatingWindowType.Products:
        return <ProductsWindow />;
      case FloatingWindowType.Alarms:
        return <AlarmsWindow />;
      default:
        return undefined;
    }
  };
  const filterByMode = (floatingWindow : FloatingWindow) => {
    if (mode === 'tile') {
      return floatingWindow.type !== FloatingWindowType.Products;
    }
    return true;
  };

  return (
    <>
      {floatingWindowsList.filter(filterByMode)
        .map(({
          title, index, top, left, type,
        }) => (
          <Window
            key={index}
            title={title}
            render={() => getComponent(type)}
            style={mode === 'tile' && type === FloatingWindowType.Alarms ? { bottom: '100px', left: '10px', top: 'auto' } : { top, left }}
          />
        ))}
    </>
  );
}

function FloatingWindowsSystem({ mode } : FloatingWindowsSystemProps) {
  const { floatingWindowsList, setFloatingWindowsList } = useContext(FloatingWindowsContext);

  const handleOnDragEnd = (
    item: {index: string},
    monitor: DragSourceMonitor<{index: string}, unknown>,
  ) => {
    const result : {top: number, left: number} | null = monitor.getDropResult();
    if (result) {
      setFloatingWindowsList(item.index, result);
    }
  };

  return (
    <WindowsList
      onDragEnd={handleOnDragEnd}
      floatingWindowsList={floatingWindowsList}
      mode={mode}
    />
  );
}

export default FloatingWindowsSystem;
